import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { saveAs } from 'file-saver';
import * as i1 from '@angular/common/http';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i4 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

class FileDownloadLibraryService {
    constructor() { }
}
FileDownloadLibraryService.ɵfac = function FileDownloadLibraryService_Factory(t) { return new (t || FileDownloadLibraryService)(); };
FileDownloadLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: FileDownloadLibraryService, factory: FileDownloadLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileDownloadLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function FileDownloadLibraryComponent_a_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵlistener("click", function FileDownloadLibraryComponent_a_0_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.download(); });
    i0.ɵɵelementStart(1, "mat-icon", 2);
    i0.ɵɵtext(2, "get_app");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class FileDownloadLibraryComponent {
    constructor(http) {
        this.http = http;
    }
    ngOnInit() {
    }
    download() {
        this.http.get(this.Path, { responseType: "arraybuffer" }).subscribe(pdf => {
            var blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, this.fileName);
        });
    }
}
FileDownloadLibraryComponent.ɵfac = function FileDownloadLibraryComponent_Factory(t) { return new (t || FileDownloadLibraryComponent)(i0.ɵɵdirectiveInject(i1.HttpClient)); };
FileDownloadLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FileDownloadLibraryComponent, selectors: [["file-download-library"]], inputs: { fileName: "fileName", Path: "Path" }, decls: 1, vars: 1, consts: [[3, "click", 4, "ngIf"], [3, "click"], ["matTooltipClass", "tooltip-bg", "matTooltip", "Download Document", 1, "material-icons"]], template: function FileDownloadLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FileDownloadLibraryComponent_a_0_Template, 3, 0, "a", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.fileName);
    } }, directives: [i2.NgIf, i3.MatIcon, i4.MatTooltip], styles: ["a[_ngcontent-%COMP%]{color:#505050;text-decoration:none;background-color:transparent}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileDownloadLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'file-download-library',
                templateUrl: './file-download.component.html',
                styleUrls: ['./file-download.component.scss']
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, { fileName: [{
            type: Input
        }], Path: [{
            type: Input
        }] }); })();

class FileDownloadLibraryModule {
}
FileDownloadLibraryModule.ɵfac = function FileDownloadLibraryModule_Factory(t) { return new (t || FileDownloadLibraryModule)(); };
FileDownloadLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: FileDownloadLibraryModule });
FileDownloadLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatTooltipModule,
            MatIconModule,
            NgbTooltipModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FileDownloadLibraryModule, { declarations: [FileDownloadLibraryComponent], imports: [CommonModule,
        MatTooltipModule,
        MatIconModule,
        NgbTooltipModule], exports: [FileDownloadLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileDownloadLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [FileDownloadLibraryComponent],
                imports: [
                    CommonModule,
                    MatTooltipModule,
                    MatIconModule,
                    NgbTooltipModule
                ],
                exports: [FileDownloadLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of file-download-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FileDownloadLibraryComponent, FileDownloadLibraryModule, FileDownloadLibraryService };
//# sourceMappingURL=file-download-library.js.map
